const routes = [
  {
    path: "/product-order/:uid",
    name: "product_order",
    component:  () => import(/* webpackChunkName: "ProductOrderPage" */ "./views/ProductOrderPage")
  }
]

export default routes;
